<div style="margin: 30px; text-align: center;">
    <h5>Página não encontrada!</h5>
    <p>{{ attemptedRoute }}</p>
    <p>
        <a href="">Ir para o início.</a>
    </p>
</div>
